import {
  WSModal,
  WSModalCustomProps,
  WSText,
  useWSModalCustom
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { PATH_SETTINGS_PAYROLL_ADD_FUNDING_METHOD } from "../../modules/Settings/paths";

const ModalAddDefaultPaymentMethodWarning: React.FC<
  WSModalCustomProps<void>
> = props => {
  const history = useHistory();
  const location = useLocation();

  return (
    <WSModal
      title="Add default funding method"
      size="XS"
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Continue",
            onClick: () => {
              props.onClose();
              history.push(PATH_SETTINGS_PAYROLL_ADD_FUNDING_METHOD, {
                backPath: location.pathname
              });
            }
          }
        ]
      }}
      {...props}
    >
      <WSText.ParagraphSm color="gray600">
        Before approving invoices, you need to configure the default funding
        method that will be used to process the invoice payment.
      </WSText.ParagraphSm>
    </WSModal>
  );
};

export const useModalAddDefaultPaymentMethodWarning = () =>
  useWSModalCustom(ModalAddDefaultPaymentMethodWarning);
